import { FormEvent, useState } from 'react';
import { LockKeyhole, Store } from 'lucide-react';
import { ApiError, StudioAuth } from '../api/client';

type Props = { onLoggedIn: () => void };

export function StudioLogin({ onLoggedIn }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await StudioAuth.login(email, password);
      onLoggedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="studio-login-page">
      <section className="studio-login-card">
        <div className="studio-login-mark"><Store size={24} strokeWidth={1.8} /></div>
        <p className="kicker kicker-brand">Private workspace</p>
        <h1 className="serif">Etsy Studio</h1>
        <p className="studio-login-copy">Sign in to manage your shop, listings, and orders.</p>
        <form onSubmit={submit} className="studio-login-form">
          <label>
            <span>Email</span>
            <input autoComplete="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          </label>
          <label>
            <span>Password</span>
            <input autoComplete="current-password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required />
          </label>
          {error && <p className="studio-login-error" role="alert">{error}</p>}
          <button className="btn btn-primary studio-login-submit" type="submit" disabled={loading}>
            <LockKeyhole size={15} /> {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </section>
    </main>
  );
}
